class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-load-more-button]');
    this.spinner = this.querySelector('[data-load-more-spinner]');
    this.grid = document.getElementById('product-grid');

    if (this.button) {
      this.button.addEventListener('click', this.loadMore.bind(this));
    }
  }

  async loadMore() {
    if (!this.button || !this.grid) return;

    const nextUrl = this.button.getAttribute('data-next-url');
    const sectionId = this.button.getAttribute('data-section-id');
    if (!nextUrl) return;

    this.button.setAttribute('disabled', 'true');
    if (this.spinner) this.spinner.hidden = false;

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('Load more request failed');
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newGrid = doc.getElementById('product-grid');
      if (newGrid) {
        Array.from(newGrid.children).forEach((item) => {
          this.grid.appendChild(item);
        });
      }

      const newWrapper = doc.querySelector('[data-load-more-wrapper]');
      const newButton = newWrapper ? newWrapper.querySelector('[data-load-more-button]') : null;

      if (newButton) {
        const newNextUrl = newButton.getAttribute('data-next-url');
        this.button.setAttribute('data-next-url', newNextUrl);
        this.button.removeAttribute('disabled');
      } else {
        this.remove();
      }
    } catch (error) {
      this.button.removeAttribute('disabled');
    } finally {
      if (this.spinner) this.spinner.hidden = true;
    }
  }
}

if (!customElements.get('load-more-products')) {
  customElements.define('load-more-products', LoadMoreProducts);
}
